<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Sobre a Imobiliária Callegaro';
</script>

<PageHeader title={titlePage}></PageHeader>
<div class="container clearfix text-justify">

	<span class="float-sm-left mr-40" style="width: 535px; text-align: center; padding-bottom: 20px;">
		<div>
			<picture class="image-gallery float-sm-left" style="display: flex;">
				<img class="img-fluid" src="/assets/images/sobre.jpg" alt="Sede da imobiliária">
			</picture>
		</div>
	</span>

	<p>Uma empresa que atua no mercado imobiliário há 30 (trinta) anos sempre buscando atender  as  necessidades  dos  clientes.  Nossos  valores  são  focados  na  transparência, competência,  ética,  honestidade,  respeito  e  seriedade.  Temos  por  tradição  buscar  a satisfação dos clientes.</p>

	<p>Iniciamos nossas atividades em 1991, como Callegaro Negócios Imobiliários na área de locações.</p>

	<p>Em  1998  adquirimos  a  sede  situada  na  Av.  Emancipação,  n°666,  Tramandaí/RS, passando  a  denominação  de  Imobiliária  Callegaro.  Além  das  locações  passamos  a  atuar na administração de condomínios e na compra e venda de imóveis.</p>

	<p>Somos  filiados  ao  SECOVI  –  Sindicato  da  Habitação,  CRECI  –  Conselho  Regional de Corretores de Imóveis e AICITI – Associação das Imobiliárias e Corretores de Imóveis de Tramandaí e Imbé.</p>

	<p>Em  novembro  de  2021  mudamos  de  sede  passando  a  ocupar  o  endereço  da  Av. Rubem Berta, n°1629, lojas 01 e 02, Tramandaí/RS.</p>

	<p>A mudança ampliou o espaço físico para o atendimento dos clientes e possibilitou o fácil estacionamento por se situar em área privilegiada.</p>

	<hr>
	<div class="button mt-40 text-center">        
		<a href="/contato" use:link replace title="" class="btn btn-secondary">
			Entre em contato com a gente <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>

	<br /><br /><br />

</div>
